export class FDID {
  catReporterIMID!:string;
  accountNumber!:string;
  name!:string;
  givenName!:string;
  role!:string;
  fdidType!:string;
  entityType!:string;
  fdid!:string;
  receivedFdid!:string;
  active!:boolean;
  fdidEffectiveDate!:string;
  fdidEndDate!:string;
  fdidEndReason!:string;
  createdUser!:string;
  createdDate!:string;
  updatedUser!:string;
  updatedDate!:string;
  replacedByFdid!:string;
  replacedByFdidDate!:string;

}

export class AccountType {
  accountType!: string;
}
